/**
 * Cart Count Animation Handler
 * Adds a pop animation to the cart count bubble when items are added to cart
 */

(function() {
  'use strict';

  /**
   * Trigger cart count bubble animation
   * Use requestAnimationFrame to ensure DOM has updated before animating
   */
  function animateCartCount() {
    setTimeout(() => {
      const cartCountBubbles = document.querySelectorAll('.cart-count-bubble');
      
      cartCountBubbles.forEach(bubble => {
        bubble.classList.remove('pop');
        
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            bubble.classList.add('pop');
            
            setTimeout(() => {
              bubble.classList.remove('pop');
            }, 600);
          });
        });
      });
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
        if (event.source === 'product-form' || event.source === 'quick-add' || event.source === 'quick-add-bulk') {
          animateCartCount();
        }
      });
    } else {
      setTimeout(init, 1000);
    }
  }

  window.animateCartCount = animateCartCount;
})();
